/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PlayerRewardStatus = {
    _11184809: '11184809',
    PENDING: 'PENDING',
    AWARDED: 'AWARDED',
    FAILED: 'FAILED',
    unknown_default_open_api: '11184809'
} as const;
export type PlayerRewardStatus = typeof PlayerRewardStatus[keyof typeof PlayerRewardStatus];


export function instanceOfPlayerRewardStatus(value: any): boolean {
    for (const key in PlayerRewardStatus) {
        if (Object.prototype.hasOwnProperty.call(PlayerRewardStatus, key)) {
            if (PlayerRewardStatus[key as keyof typeof PlayerRewardStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PlayerRewardStatusFromJSON(json: any): PlayerRewardStatus {
    return PlayerRewardStatusFromJSONTyped(json, false);
}

export function PlayerRewardStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerRewardStatus {
    return json as PlayerRewardStatus;
}

export function PlayerRewardStatusToJSON(value?: PlayerRewardStatus | null): any {
    return value as any;
}

